import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './SimulatedRemoveModalMessages';

function SimulatedRemoveSuccessfullyModal({ intl, isOpen, ability, onClose, onContinue }) {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon="pe-7s-close-circle"
      title={intl.formatMessage(messages.success)}
      subtitle={intl.formatMessage(messages.feedback, { ability: ability ? ability.content : '' })}
      buttons={[
        {
          label: intl.formatMessage(messages.continue),
          onClick: onContinue,
          primary: true,
        },
      ]}
      small
    />
  );
}

export default injectIntl(SimulatedRemoveSuccessfullyModal);
